const BASE_ID_SCHEMA_FIELD_ID = 'airtableBaseId';
const TABLE_ID_SCHEMA_FIELD_ID = 'airtableTableId';

export { BASE_ID_SCHEMA_FIELD_ID, TABLE_ID_SCHEMA_FIELD_ID };
